export default __webpack_public_path__ + "static/media/delete.bb8494aa.svg";